module.exports = __webpack_public_path__ + "static/media/tablet-android-alt.817abce1.svg";